<template>  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Vendas do dia {{data_inicio_cabecalho}} à {{data_fim_cabecalho}}</h4>
          </div>
          <div class="row">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_fim">
            <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile " v-on:click.native="filtrar" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Filtrar</n-button>
            <div class="col-6 col-sm-4 col-md-3">
              <download-excel
                :fetch="fetchData"
                :title="'Relatório por CFOP de ' + data_inicio_cabecalho + ' até ' + data_fim_cabecalho"
                name="Relatório de CFOP"
              >
                <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile " style="height:30px;margin-left: 20px;padding:0;margin-top:0;float: right">Exportar Excel</n-button>
              </download-excel>
            </div>
          </div>
          
          <table class="display responsive nowrap table table-hover table-striped table-bordered hidden-mobile">
            <thead>
              <tr>
                <th>CFOP</th>
                <th>CST</th>
                <th class="text-right">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="venda of vendas">
                <td class="text-right">{{ venda.cfop }}</td>
                <td class="text-right">{{ venda.cst }}</td>  
                <td class="text-right pr-3">{{ venda.valor | currencyBrl(true) }}</td>
              </tr>
              <tr v-if="!vendas || !vendas.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
    AnimatedNumber,
    Progress as NProgress,
    LineChart
  } from 'src/components'
import { setInterval } from 'timers';
import {Table, TableColumn} from 'element-ui'
import HeaderChart from '../Dashboard/HeaderChart'
import moment from 'moment'
import GlobalFunctions from '../../../globalFunctions.js'
import VendaService from '@/services/VendaService.js'

export default {
    components: {
      Card,
      AnimatedNumber,
      LineChart,
      NProgress,
      HeaderChart,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      moment
    },
    data() {
      return {
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
        mobile:GlobalFunctions.isMobile(),
        vendas: [],
        modulo_mfe: localStorage.getItem('config_modulo_mfe') == "true" ? true : false,
      }
    },
    methods:{
      async fetchData() {
        let response
        console.log(this.modulo_mfe)
        if(this.modulo_mfe){
          response = await VendaService.loadCFOPMfe(`?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}`)
        }else{
          response = await VendaService.loadCFOP(`?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}`)
        }
        let dados = []

        for(let item of response.data) {
          let tmp = {};
          tmp["CFOP"] = item.cfop
          tmp["CST"] = item.cst
          tmp.Valor = this.$options.filters.currencyBrl(item.valor)

          dados.push(tmp)
        }

        return dados;
      },
      
      changePage(page) {
        this.current_page = page
        this.loadVendas()
      },

      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadVendas();
      },
      loadVendas() {
        let loader = this.$loading.show();
        if(this.modulo_mfe){
          VendaService.loadCFOPMfe(`?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}`).then(res => {
            this.vendas = res.data;
            loader.hide()
          }).catch(err => {
            loader.hide()
          })
        }else{
          VendaService.loadCFOP(`?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}`).then(res => {
            this.vendas = res.data;
            loader.hide()
          }).catch(err => {
            loader.hide()
          })
        }
      },
    },
    mounted() {
      this.loadVendas()
    }
}
</script>